import React, { useEffect, useRef, useState } from "react";
import LayoutContainer from "../../components/Containers/LayoutContainer";
import PageHeader from "../../components/PageHeader/PageHeader";
import { ArrowLeft, TrashFill } from "react-bootstrap-icons";
import CommonTable, { TableColumn } from "../../components/Table/CommonTable";
import { hideLoader, showLoader } from "../../store/Loader/loader.slice";
import { postDetails } from "../../services/http/http.service";
import APIList from "../../utils/constants/APIList";
import { useAppDispatch } from "../../store/storeRequests";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Modal } from "react-bootstrap";
import defaultProfile from "../../assets/default-profile.png";
import convertTimestamp from "../../utils/helpers/convertTimeStamp";
import { hideToast, showToast } from "../../store/Toast/toast.slice";
import sortByCreated from "../../utils/helpers/sortByCreated";
import formatDate from "../../utils/helpers/formatDate";
import CustomButton from "../../components/CustomButton/CustomButton";

interface Folder {
  id:number;
  created :any;
  name:string;
  profile :any;
  text :string;
  // post_status:string;
  // profile:any;
  // reportRemarkByAdmin:any;
  // reportRemarkByAdminDate:any;
  // reports_count:number;
  // status:number;
}



const Report_User: React.FunctionComponent = () => {
  const cmpMounted = useRef(false);
  const dispatch = useAppDispatch();
//   const params = useParams();
  const [feed, setFeed] = useState<Folder[]>([]);
  const location = useLocation();
  // const { item, pageName } = location.state;
  const [selectedItems, setSelectedItems] = useState<Set<number>>(new Set());
  const [showDeleteModal, setShowDeleteModal] = useState(false);
 
  const navigate = useNavigate();
  // console.log(location.name)

  useEffect(() => {
    if (cmpMounted.current === true) return;
    cmpMounted.current = true;
    
      fetchNewsFeed();
  }, []);


  const fetchNewsFeed = async () => {
    try {
      dispatch(showLoader("Loading data..."));
      const payload = {
        news_feed_id: location.state.item.id,
        sortType: "report",
      };
      const response = await postDetails(APIList.VIEW_NEWS_FEED, payload);
      console.log("Response Feed",response);
      const sortedFeed = sortByCreated(response.data)
      console.log("Sorted Feed",response);
      const modifiedFeed = sortedFeed.map((item: any) => ({
        ...item,
        name: item.userInfo?.name,
        profile: item.userInfo?.profile || defaultProfile,
        // created: formatDate(item.created, "year-month-time")
      }));
      setFeed(modifiedFeed);
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(showToast(`Some error occurred while fetching data.`));
      setTimeout(() => dispatch(hideToast()), 3000);
    } finally {
      dispatch(hideLoader());
    }
  };

  const deleteItemById = async (item: Folder) => {
    try {
        dispatch(showLoader('Loading data...'));
      const response = await postDetails(APIList.DELETE_REPORT, { id: item.id });
      if (response.status === "Failed") {
        dispatch(showToast(`Cannot delete report`));
        setTimeout(() => dispatch(hideToast()), 3000);
        return;
      }
      setFeed((prevData: any) =>
        prevData.filter((row: Folder) => row.id !== item.id)
      );
    } catch (error) {
      console.error("Error deleting report:", error);
      dispatch(showToast(`An error occurred while trying to delete the report. Please try again.`));
      setTimeout(() => dispatch(hideToast()), 3000);
    }
    finally {
        dispatch(hideLoader());
    }
  };

  const handleBackToList = () => {
    console.log(location.state.pageName);  
    if (location.state.pageName === 'Wall') {
      navigate("/wall");
    } else {
      navigate("/culturalPost");
    }
  };

  const handleBulkDelete = async () => {
    try {
      const ids = Array.from(selectedItems)
      console.log(ids)
      const response = await postDetails(APIList.DELETE_REPORT, {id: ids})
      console.log(response)

      if(response.status === "Failed"){
        dispatch(showToast(`Cannot delete posts`));
        setTimeout(() => dispatch(hideToast()), 3000);
        return;
      }

      dispatch(showToast("posts deleted successfully."));
      setTimeout(() => dispatch(hideToast()), 3000);
      setSelectedItems(new Set());
      fetchNewsFeed()
    } catch (error) {
      console.error("Error deleting posts:", error);
      alert("Some error occurred while deleting posts.")
    } finally{
      setShowDeleteModal(false)
    }
  };

  const buttons = [
    {
      label: "Delete",
      theme: "danger",
      icon: <TrashFill />,
      onClick: ()=> setShowDeleteModal(true),
      disabled: selectedItems.size === 0,
      
    },
    {
      label: "Back To Main List" ,
      theme: "danger",
      icon: <ArrowLeft />,
      onClick:handleBackToList,
    },
  ];

  const columns: TableColumn[] = [
    // {key:"id",label:"id"},
    {
      key: "profile",
      label: "Profile Pic",
      sortable: false,
      dataType: "image",
    },
    { key: "name", label: "User Name", sortable: true , dataType: "string"},
    // { key: "text", label: "text", sortable: true , dataType: "string"},
    { key: "text", label: "Text" , 
      // render: (item) => {
      //   return (
      //     <p 
      //     // className="fixed-container"
      //     // style={{width: "auto"}}
      //     >{item.text}</p>
      //   )
      // },
      dataType: "string",
      sortable: true,
      //  search:true,
    },
    { key: "created",
       label: "Date", 
      sortable: true , 
      //  search:true,
      // dataType: "string"
      render: (record) => {
        if(record.created){
       return new Date(record.created).toLocaleString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        })
        } else{
          return ""
        }

      },
    },

  ];

  const handleCheckboxChange = (selectedIds: Set<number>) => {
    console.log(selectedIds);
    setSelectedItems(selectedIds);
  };

  const handleCloseModal = () => setShowDeleteModal(false);

  return (
    <LayoutContainer title="report-user">
      <Modal show={showDeleteModal} onHide={handleCloseModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            Confirm Delete
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="mb-4">Are you sure you want to delete?</p>
          <div className="d-flex flex-column-reverse flex-md-row align-items-md-center justify-content-md-center gap-3 mb-2">
              <CustomButton theme="yellow" size="md" onClick={handleBulkDelete}>
                Delete
              </CustomButton>
              <CustomButton theme="red" size="md" onClick={handleCloseModal}>
                Cancel
              </CustomButton>
            </div>
        </Modal.Body>
      </Modal>
      <div className=" page-header d-flex align-items-center justify-content-left dashboard-container h-100 mb-4">
        <h2>
          <i className="page-header-icon fa fa fa-list"></i>
          View Report User
        </h2>
      <PageHeader buttons={buttons} />
      </div>

      <CommonTable<Folder>
        data={feed}
        columns={columns}
        // onEdit={editItem}
        onDelete={deleteItemById}
        // onStatusToggle={(item)=> console.log(item)}
        pagination={true}
        rowsPerPage={10}
        actions={{
          view: false,
          edit: false,
          delete: true,
          checkbox: true,
          status: false,
          showModal: false,
        }}
        onCheckboxChange={handleCheckboxChange}
      />
    </LayoutContainer>
  );
};

export default Report_User;
